export const recognitionLanguages = [
  "af-ZA",
  "am-ET",
  "ar-EG",
  "az-AZ",
  "bg-BG",
  "bn-IN",
  "bs-BA",
  "ca-ES",
  "cs-CZ",
  "cy-GB",
  "da-DK",
  "de-DE",
  "el-GR",
  "en-US",
  "es-ES",
  "et-EE",
  "eu-ES",
  "fa-IR",
  "fi-FI",
  "fil-PH",
  "fr-FR",
  "ga-IE",
  "gl-ES",
  "gu-IN",
  "he-IL",
  "hi-IN",
  "hr-HR",
  "hu-HU",
  "hy-AM",
  "id-ID",
  "is-IS",
  "it-CH",
  "it-IT",
  "ja-JP",
  "jv-ID",
  "ka-GE",
  "kk-KZ",
  "km-KH",
  "kn-IN",
  "ko-KR",
  "lo-LA",
  "lt-LT",
  "lv-LV",
  "mk-MK",
  "ml-IN",
  "mn-MN",
  "mr-IN",
  "ms-MY",
  "mt-MT",
  "my-MM",
  "nb-NO",
  "ne-NP",
  "nl-NL",
  "pl-PL",
  "ps-AF",
  "pt-PT",
  "ro-RO",
  "ru-RU",
  "si-LK",
  "sk-SK",
  "sl-SI",
  "so-SO",
  "sq-AL",
  "sr-RS",
  "sv-SE",
  "sw-KE",
  "sw-TZ",
  "ta-IN",
  "te-IN",
  "th-TH",
  "tr-TR",
  "uk-UA",
  "uz-UZ",
  "vi-VN",
  "wuu-CN",
  "yue-CN",
  "zh-CN",
];
export const audioClipList = [
  {
    label: "A taste of the whip 343",
    path: "/assets/audio/a-taste-of-the-whip-343.mp3",
    value: "a-taste-of-the-whip-343",
  },
  {
    label: "Alarming 304",
    path: "/assets/audio/alarming-304.mp3",
    value: "alarming-304",
  },
  {
    label: "Another message has arrived 215",
    path: "/assets/audio/another-message-has-arrived-215.mp3",
    value: "another-message-has-arrived-215",
  },
  {
    label: "Anxious 586",
    path: "/assets/audio/anxious-586.mp3",
    value: "anxious-586",
  },
  {
    label: "Appointed 529",
    path: "/assets/audio/appointed-529.mp3",
    value: "appointed-529",
  },
  {
    label: "Argh my eyes 288",
    path: "/assets/audio/argh-my-eyes-288.mp3",
    value: "argh-my-eyes-288",
  },
  {
    label: "Arp 270",
    path: "/assets/audio/arp-270.mp3",
    value: "arp-270",
  },
  {
    label: "Arpeggio 467",
    path: "/assets/audio/arpeggio-467.mp3",
    value: "arpeggio-467",
  },
  {
    label: "Case closed 531",
    path: "/assets/audio/case-closed-531.mp3",
    value: "case-closed-531",
  },
  {
    label: "Chin up 554",
    path: "/assets/audio/chin-up-554.mp3",
    value: "chin-up-554",
  },
  {
    label: "Confident 543",
    path: "/assets/audio/confident-543.mp3",
    value: "confident-543",
  },
  {
    label: "Definite 555",
    path: "/assets/audio/definite-555.mp3",
    value: "definite-555",
  },
  {
    label: "Door 9 close",
    path: "/assets/audio/door-9-close.ogg",
    value: "door-9-close",
  },
  {
    label: "Doorbell 1",
    path: "/assets/audio/doorbell-1.ogg",
    value: "doorbell-1",
  },
  {
    label: "Dropped 233",
    path: "/assets/audio/dropped-233.mp3",
    value: "dropped-233",
  },
  {
    label: "Echoed ding 459",
    path: "/assets/audio/echoed-ding-459.mp3",
    value: "echoed-ding-459",
  },
  {
    label: "Elegant notification sound",
    path: "/assets/audio/elegant-notification-sound.mp3",
    value: "elegant-notification-sound",
  },
  {
    label: "Eventually 590",
    path: "/assets/audio/eventually-590.mp3",
    value: "eventually-590",
  },
  {
    label: "Filling your inbox 251",
    path: "/assets/audio/filling-your-inbox-251.mp3",
    value: "filling-your-inbox-251",
  },
  {
    label: "Gentle alarm 474",
    path: "/assets/audio/gentle-alarm-474.mp3",
    value: "gentle-alarm-474",
  },
  {
    label: "Gesture 192",
    path: "/assets/audio/gesture-192.mp3",
    value: "gesture-192",
  },
  {
    label: "Going up 186",
    path: "/assets/audio/going-up-186.mp3",
    value: "going-up-186",
  },
  {
    label: "Good news 387",
    path: "/assets/audio/good-news-387.mp3",
    value: "good-news-387",
  },
  {
    label: "Good things happen 547",
    path: "/assets/audio/good-things-happen-547.mp3",
    value: "good-things-happen-547",
  },
  {
    label: "Graceful 558",
    path: "/assets/audio/graceful-558.mp3",
    value: "graceful-558",
  },
  {
    label: "Hell yeah somewhat calmer 358",
    path: "/assets/audio/hell-yeah-somewhat-calmer-358.mp3",
    value: "hell-yeah-somewhat-calmer-358",
  },
  {
    label: "Hello 330",
    path: "/assets/audio/hello-330.mp3",
    value: "hello-330",
  },
  {
    label: "Here I am 449",
    path: "/assets/audio/here-i-am-449.mp3",
    value: "here-i-am-449",
  },
  {
    label: "I did it message tone",
    path: "/assets/audio/i-did-it-message-tone.mp3",
    value: "i-did-it-message-tone",
  },
  {
    label: "Inflicted 601",
    path: "/assets/audio/inflicted-601.mp3",
    value: "inflicted-601",
  },
  {
    label: "Juntos 607",
    path: "/assets/audio/juntos-607.mp3",
    value: "juntos-607",
  },
  {
    label: "Just saying 593",
    path: "/assets/audio/just-saying-593.mp3",
    value: "just-saying-593",
  },
  {
    label: "Long chime sound 455",
    path: "/assets/audio/long-chime-sound-455.mp3",
    value: "long-chime-sound-455",
  },
  {
    label: "Maybe 552",
    path: "/assets/audio/maybe-552.mp3",
    value: "maybe-552",
  },
  {
    label: "My work is done message tone",
    path: "/assets/audio/my-work-is-done-message-tone.mp3",
    value: "my-work-is-done-message-tone",
  },
  {
    label: "Not bad 549",
    path: "/assets/audio/not-bad-549.mp3",
    value: "not-bad-549",
  },
  {
    label: "Not kiddin 243",
    path: "/assets/audio/not-kiddin-243.mp3",
    value: "not-kiddin-243",
  },
  {
    label: "Standard Notification",
    path: "/assets/audio/notification.mp3",
    value: "notification",
  },
  {
    label: "Office 2 453",
    path: "/assets/audio/office-2-453.mp3",
    value: "office-2-453",
  },
  {
    label: "Oh finally 355",
    path: "/assets/audio/oh-finally-355.mp3",
    value: "oh-finally-355",
  },
  {
    label: "Pristine 609",
    path: "/assets/audio/pristine-609.mp3",
    value: "pristine-609",
  },
  {
    label: "Quite impressed 565",
    path: "/assets/audio/quite-impressed-565.mp3",
    value: "quite-impressed-565",
  },
  {
    label: "Ringing bells 2 278",
    path: "/assets/audio/ringing-bells-2-278.mp3",
    value: "ringing-bells-2-278",
  },
  {
    label: "Standard send message",
    path: "/assets/audio/send-message.mp3",
    value: "send-message",
  },
  {
    label: "Soft bells 495",
    path: "/assets/audio/soft-bells-495.mp3",
    value: "soft-bells-495",
  },
  {
    label: "Solemn 522",
    path: "/assets/audio/solemn-522.mp3",
    value: "solemn-522",
  },
  {
    label: "SOS",
    path: "/assets/audio/sos.mp3",
    value: "sos",
  },
  {
    label: "Succeeded message tone",
    path: "/assets/audio/succeeded-message-tone.mp3",
    value: "succeeded-message-tone",
  },
  {
    label: "Sunny 329",
    path: "/assets/audio/sunny-329.mp3",
    value: "sunny-329",
  },
  {
    label: "To the point 568",
    path: "/assets/audio/to-the-point-568.mp3",
    value: "to-the-point-568",
  },
  {
    label: "You have new message 484",
    path: "/assets/audio/you-have-new-message-484.mp3",
    value: "you-have-new-message-484",
  },
  {
    label: "You've been informed 345",
    path: "/assets/audio/youve-been-informed-345.mp3",
    value: "youve-been-informed-345",
  },
];
export const CORE_COMMUNICATOR_ENABLED = "core:communicatorEnabled";
export const CORE_ALERT_ENABLED = "core:alertEnabled";
export const CORE_CONNECT_ENABLED = "core:connectEnabled";
export const CONVEY_COMMUNICATOR = {
  name: "ConveyCommunicator",
  routeName: "Conversations Dashboard",
  setting: CORE_COMMUNICATOR_ENABLED,
};
export const CONVEY_ALERT = {
  name: "ConveyAlert",
  routeName: "Campaigns",
  setting: CORE_ALERT_ENABLED,
};
export const CONVEY_CONNECT = {
  name: "ConveyConnect",
  routeName: "Convey Connect Dashboard",
  setting: CORE_CONNECT_ENABLED,
};
export const mimeTypes = {
  "text/html": ".html",
  "text/css": ".css",
  "text/xml": ".xml",
  "image/gif": ".gif",
  "image/jpeg": ".jpeg",
  "application/x-javascript": ".js",
  "application/atom+xml": ".atom",
  "application/rss+xml": ".rss",
  "text/mathml": ".mml",
  "text/plain": ".txt",
  "text/vnd.sun.j2me.app-descriptor": ".jad",
  "text/vnd.wap.wml": ".wml",
  "text/x-component": ".htc",
  "image/png": ".png",
  "image/tiff": ".tif",
  "image/vnd.wap.wbmp": ".wbmp",
  "image/x-icon": ".ico",
  "image/x-jng": ".jng",
  "image/x-ms-bmp": ".bmp",
  "image/svg+xml": ".svg",
  "image/webp": ".webp",
  "application/java-archive": ".jar",
  "application/mac-binhex40": ".hqx",
  "application/msword": ".doc",
  "application/pdf": ".pdf",
  "application/postscript": ".ps",
  "application/rtf": ".rtf",
  "application/vnd.ms-excel": ".xls",
  "application/vnd.ms-powerpoint": ".ppt",
  "application/vnd.wap.wmlc": ".wmlc",
  "application/vnd.google-earth.kml+xml": ".kml",
  "application/vnd.google-earth.kmz": ".kmz",
  "application/x-7z-compressed": ".7z",
  "application/x-cocoa": ".cco",
  "application/x-java-archive-diff": ".jardiff",
  "application/x-java-jnlp-file": ".jnlp",
  "application/x-makeself": ".run",
  "application/x-perl": ".pl",
  "application/x-pilot": ".prc",
  "application/x-rar-compressed": ".rar",
  "application/x-redhat-package-manager": ".rpm",
  "application/x-sea": ".sea",
  "application/x-shockwave-flash": ".swf",
  "application/x-stuffit": ".sit",
  "application/x-tcl": ".tcl",
  "application/x-x509-ca-cert": ".der",
  "application/x-xpinstall": ".xpi",
  "application/xhtml+xml": ".xhtml",
  "application/zip": ".zip",
  "application/octet-stream": ".bin",
  "audio/midi": ".mid",
  "audio/mpeg": ".mp3",
  "audio/ogg": ".ogg",
  "audio/x-realaudio": ".ra",
  "audio/pcm": ".wav",
  "audio/3gp": ".3gp",
  "audio/3gpp": ".3gpp",
  "video/3gp": ".3gp",
  "video/3gpp": ".3gpp",
  "video/mpeg": ".mpeg",
  "video/quicktime": ".mov",
  "video/x-flv": ".flv",
  "video/x-mng": ".mng",
  "video/x-ms-asf": ".asx",
  "video/x-ms-wmv": ".wmv",
  "video/x-msvideo": ".avi",
  "video/mp4": ".m4v"
};
